{
  "stream": "Поток",
  "codecLabel": "Кодек",
  "codecUnknown": "кодек не определён",
  "codecH265Warning": "H.265 — браузер декодирует не везде",
  "mainStream": "основной поток",
  "noSubstream": "не задан — сетка 2×2 пойдёт на основном потоке",
  "resolution": "Разрешение",
  "resolutionUnknown": "не определено",
  "probe": "Проверка",
  "notProbed": "не проводилась",
  "probeStream": "Проверить поток",
  "noRtspCredential": "Пароль RTSP не привязан — камера должна пускать без него.",
  "cameraDisabled": "Камера отключена в настройках",
  "toWall": "На стену",
  "createCamera": "Завести камеру",
  "noCameraForbidden": "Камера на этом узле не заведена. Завести её может тот, кому доверено менять узлы.",
  "newCameraHint": "Камера на этом узле ещё не заведена. Укажите путь потока — адрес берётся у узла, пароль из учётных данных. Ссылку целиком тоже можно вставить: путь из неё возьмётся сам.",
  "notSet": "не задан",
  "transportLabel": "Транспорт",
  "enabled": "Включена",
  "disabledHint": "Отключённая камера не показывается на стене",
  "noCameras": "Камер пока нет. Заведите узел типа «камера» на карте сети и укажите ему путь RTSP в свойствах камеры.",
  "mediaServerRejected": "Медиасервер отклонил подключение ({{status}}).",
  "startTimeout": "Поток не пошёл за отведённое время. Проверьте, отвечает ли камера (кнопка «Проверить поток» в свойствах узла) и не режет ли сеть видеотрафик.",
  "openFailed": "Поток не удалось открыть.",
  "vendor": {
    "generic": "Обычная камера",
    "hikvision": "Hikvision",
    "dahua": "Dahua",
    "axis": "Axis",
    "onvif": "ONVIF"
  },
  "transport": {
    "tcp": "TCP — работает и через агента площадки",
    "udp": "UDP — только в одной сети с платформой"
  },
  "stage": {
    "opening": "открываем поток",
    "webrtc": "WebRTC",
    "fallback": "резервный канал"
  },
  "codec": {
    "mainH265": "Основной поток в H.265 — браузер его не декодирует, показан substream.",
    "h265Advice": "Браузер не декодирует H.265. Включите на камере второй поток (substream) в H.264 и укажите его путь в настройках камеры — раскладка возьмёт его сама. Другой выход — транскодирование на сервере, но оно нагружает его на каждую камеру. В Safari 17 этот поток открывается без изменений; на Windows — в Edge и в Chrome, если из Microsoft Store поставлено расширение «HEVC Video Extensions».",
    "undecodable": "Браузер не декодирует этот поток."
  },
  "player": {
    "webrtcFailed": "WebRTC-соединение не установилось.",
    "noFallback": "Браузер не поддерживает резервный транспорт.",
    "audioOnly": "Медиасервер отдал только звуковую дорожку: видео этого потока браузер не декодирует. Почти всегда это H.265 — на Windows он играет после установки расширения «HEVC Video Extensions» из Microsoft Store, в Safari 17+ играет сразу.",
    "undecodable": "Браузер не декодирует этот поток.",
    "fallbackUnavailable": "Резервный канал недоступен.",
    "fallbackClosed": "Резервный канал закрыт сервером."
  },
  "cell": {
    "snapshot": "Снимок кадра",
    "zoomIn": "Увеличить область",
    "zoomReset": "Сбросить увеличение",
    "panLeft": "Сдвинуть влево",
    "panRight": "Сдвинуть вправо",
    "clear": "Убрать камеру из ячейки",
    "selected": "ячейка выбрана",
    "empty": "пустая ячейка",
    "selectedHint": "Щёлкните камеру в списке слева — она встанет сюда",
    "emptyHint": "Перетащите сюда камеру из списка слева или щёлкните ячейку, чтобы выбрать её",
    "mseFallback": "mse · резервный транспорт",
    "streamSwapped": "поток подменён",
    "snapshotSaved": "снимок сохранён",
    "channelN": "Канал {{channel}}",
    "pickChannel": "Выбрать канал"
  },
  "recorder": {
    "title": "Видеорегистратор",
    "newHint": "Регистратор на этом узле ещё не заведён. Выберите, как с ним говорить: адрес берётся у узла, пароль — из учётных данных RTSP. Каналы платформа определит сама сразу после заведения.",
    "forbidden": "Регистратор на этом узле не заведён. Завести его может тот, кому доверено менять узлы.",
    "protocolLabel": "Протокол",
    "protocol": {
      "dahua": "Dahua — HTTP API",
      "hikvision": "Hikvision — ISAPI",
      "rtsp": "Только RTSP — каналы перебором"
    },
    "httpPort": "Порт веб-интерфейса",
    "httpPortHint": "на нём живёт API регистратора",
    "rtspPort": "Порт RTSP",
    "mainTemplate": "Основной поток",
    "subTemplate": "Substream",
    "templateHint": "{channel} заменяется номером канала. Каналы платформа найдёт перебором: пробует 1, 2, 3… и останавливается на серии молчащих.",
    "preset": "Подставить:",
    "maxChannels": "Каналов до",
    "create": "Завести регистратор",
    "detect": "Определить каналы",
    "detecting": "Определяем каналы…",
    "detected": "Найдено каналов: {{found}}. Новых: {{added}}, убрано: {{removed}}.",
    "channels": "Каналы",
    "channelsDetected_one": "определён {{count}} канал",
    "channelsDetected_few": "определено {{count}} канала",
    "channelsDetected_many": "определено {{count}} каналов",
    "channelsDetected_other": "определено {{count}} канала",
    "withoutVideo": "{{silent}} без видео",
    "noChannels": "ещё не определены",
    "channelUnavailable": "нет видео",
    "lastDetect": "Определение",
    "neverDetected": "не проводилось",
    "noCredential": "Пароль RTSP не привязан — регистратор должен пускать без него.",
    "enabledHint": "Отключённый регистратор не отдаёт каналы на стену",
    "archiveHint": "Номер канала и дорожку каждому каналу платформа проставляет сама."
  },
  "sound": {
    "on": "Включить звук",
    "off": "Выключить звук",
    "volume": "Громкость",
    "volumeAt": "Громкость {{percent}}%",
    "mutedShort": "выкл",
    "unavailable": "без звука",
    "unavailableHint": "Камера не передаёт звук: микрофон выключен в её настройках или его нет"
  },
  "overlay": {
    "h265": "H.265 без транскодирования",
    "codecUnsupported": "Браузер не декодирует поток",
    "streamFailed": "Поток не пошёл",
    "cameraSilent": "Камера не отвечает. Проверьте питание и связь с площадкой, затем повторите.",
    "retry": "Повторить подключение"
  },
  "hint": {
    "site": "Площадка: {{name}}",
    "address": "Адрес: {{address}}",
    "noAddress": "не задан",
    "notes": "Описание: {{notes}}",
    "disabled": "Камера отключена в настройках — потока не будет"
  },
  "rtsp": {
    "hostAlready": "адрес {{host}} уже указан у узла",
    "hostMove": "адрес {{host}} перенесите в поле «Адрес» самого узла",
    "portBelow": "порт {{port}} укажите ниже",
    "user": "имя заведите в учётных данных вида RTSP и привяжите к узлу — ниже",
    "userAndPassword": "имя и пароль заведите в учётных данных вида RTSP и привяжите к узлу — ниже",
    "pathOnly": "Из ссылки взят только путь: {{parts}}."
  },
  "wall": {
    "cameras": "Камеры",
    "loadingCameras": "Загружаем камеры…",
    "streamLimit": "Больше {{limit}} потоков одновременно платформа не открывает. Уберите камеру из другой ячейки.",
    "layoutName": "Название раскладки",
    "layoutExample": "Смена · день",
    "layoutSaved": "Раскладка «{{name}}» сохранена.",
    "layoutDeleted": "Раскладка удалена. Камеры на стене остались.",
    "soundBlocked": "Браузер не дал включить звук сам — он разрешает его только после действия человека. Нажмите на динамик в углу ячейки.",
    "customGrid": "Произвольная раскладка",
    "gridTitle": "Раскладка {{grid}}",
    "custom": "своя",
    "layout": "Раскладка",
    "noLayout": "не выбрана",
    "shared": "общая",
    "state": "Состояние стены",
    "streamsOf": "Потоков: {{open}} из {{limit}}.",
    "streamsShort": "{{open}} потоков / {{limit}}",
    "quality": "Качество: {{note}}.",
    "transport": "Транспорт: {{list}}.",
    "deleteLayout": "Удалить раскладку",
    "saveLayout": "Сохранить раскладку",
    "camerasCount": "Камеры · {{count}}",
    "channelsShort": "каналов: {{count}}",
    "pickHintLabel": "Как расставлять камеры",
    "pickHint": "Щёлкните ячейку, потом камеру — она встанет в выбранную. Или перетащите камеру в ячейку. Двойной клик по ячейке — полный экран, основной поток и звук."
  },
  "onWall": "на стене",
  "title": "Видео",
  "warning": {
    "noSubstream": "У камеры не задан substream — показан основной поток. Это нагружает канал.",
    "substreamSilent": "Substream не отвечал при последней проверке — показан основной поток."
  }
}
